import React from 'react';
import Header from '../component/layout/Header';
import Hero from '../component/support/Hero';
import Form from '../component/support/Form';
import FAQ from '../component/support/FAQ';
import Footer from '../component/layout/Footer';

export default function Support() {
  return (
    <div>
      <Header />
      <Hero />
      <Form />
      <FAQ />
      <Footer />
    </div>
  )
}